import {
  CommonSelectors,
  isEventAtCoordinates
} from '@/libs/map-draw/lib-utils'

function checkAttributes(state, editor, component) {
  editor.creatingCallback = () => {
    editor.isDrawing = false
    this.changeMode('simple_select', { featureIds: [state.line.id] })
  }
  editor.creatingObject = state.line
  component.toggleCreateModal(true)
}

export const createDrawLineStringMode = (MapboxDraw, editor, component) => {
  const DrawLineString = MapboxDraw.modes.draw_line_string

  function finishDrawing(state) {
    const { withAttributes } = editor

    if (withAttributes) {
      checkAttributes.call(this, state, editor, component)
    } else {
      editor.isDrawing = false
      return this.changeMode('simple_select', {
        featureIds: [state.line.id]
      })
    }
  }

  DrawLineString.clickAnywhere = function(state, e) {
    if (
      (state.currentVertexPosition > 0 &&
        isEventAtCoordinates(
          e,
          state.line.coordinates[state.currentVertexPosition - 1]
        )) ||
      (state.direction === 'backwards' &&
        isEventAtCoordinates(
          e,
          state.line.coordinates[state.currentVertexPosition + 1]
        ))
    ) {
      finishDrawing.call(this, state)
      return
    }

    this.updateUIClasses({ mouse: 'add' })
    state.line.updateCoordinate(
      state.currentVertexPosition,
      e.lngLat.lng,
      e.lngLat.lat
    )

    if (state.direction === 'forward') {
      if (state.currentVertexPosition === 0) editor.isDrawing = true
      state.currentVertexPosition++
      state.line.updateCoordinate(
        state.currentVertexPosition,
        e.lngLat.lng,
        e.lngLat.lat
      )
    } else {
      state.line.addCoordinate(0, e.lngLat.lng, e.lngLat.lat)
    }
  }

  DrawLineString.clickOnVertex = function(state) {
    finishDrawing.call(this, state)
  }

  DrawLineString.onKeyUp = function(state, e) {
    if (CommonSelectors.isEnterKey(e)) {
      finishDrawing.call(this, state)
    } else if (CommonSelectors.isEscapeKey(e)) {
      editor.isDrawing = false
      this.deleteFeature([state.line.id], { silent: true })
      this.changeMode('simple_select')
    }
  }

  return DrawLineString
}
